import * as React from 'react';
import LOCALE_MESSAGES from './locales';
var LocaleContext = /*#__PURE__*/React.createContext('zh-CN');
LocaleContext.displayName = 'LocaleContext';
export var LocaleConsumer = LocaleContext.Consumer;
export var LocaleProvider = LocaleContext.Provider;
export { LOCALE_MESSAGES };
export default LocaleContext;